import { LogDeletedUserList } from 'pages/configurations/log_deleted_users';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'log_deleted_users',
  label: 'Alunos excluídos',
  list: LogDeletedUserList,
  actions: ['list'],
  parentName: 'configurations'
};

export default generateResources(resource);
